<template>
  <nav>
    <v-card
      max-width="960px"
      elevation="0"
      class="mx-auto fill-height pa-5"
      align="center"
      color="background"
    >
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col
          fill-height
          align="center"
        >
          <v-img
            :src="require('../../assets/image3.png')"
            width="100%"
            max-width="400px"
            class="mx-auto mb-10"
          />
          <p class="text-h5 font-weight-bold">
            {{ $t('hubNotAccessTitle') }}
          </p>
          <p
            v-if="role == 'NA' && !isAuth"
            class="text-body-1"
          >
            {{ $t('hubNotAccessTextAnonymous') }}
          </p>
          <p
            v-else
            class="text-body-1"
          >
            {{ $t('hubNotAccessText') }}
          </p>         
          <v-btn
            v-if="role == 'NA' && !isAuth"
            data-testid="login-button"
            mx-auto
            color="accent"
            class="rounded-xxl text-none px-10"
            elevation="2"
            @click="login"
          >
            {{ $t('logIn') }}
          </v-btn>
          <v-btn
            v-else
            data-testid="redirect-to-my-spaces-button"
            mx-auto
            color="accent"
            class="rounded-xxl text-none px-10"
            elevation="2"
            @click="redirectToMySpaces"
          >
            {{ $t('forbiddenBtnRedirectToMySpaces') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </nav>
</template>
<script>

export default {
    data(){
      return{
            isAuth: window.$cookies.get("token")? true: false,
            space: window.location.host.split('.')[0],
            hubId: this.$route.params.id,
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            
      }
    },
    async beforeRouteEnter(to, from, next) {
        if(from.name == null){
            next({
                path: '/',
            })
        }
        next();
    },
    methods: {
        login(){
          window.location.href = process.env.VUE_APP_PROTOCOL + "://" + this.space + "." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.$route.query.referer
        },
         redirectToMySpaces(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/spaces"
        }
    }
    
}
</script>
